// extracted by mini-css-extract-plugin
export default {"main_section":"kids_main_section__OA-xb","product_section":"kids_product_section__emiAb"};